import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet";
import ScrollTop from "./ScrollTop";
import Content from "../components/ContentHeader.js";
import Route from "../components/Route.js";
import Slogan from "./Slogan";

// css
import "../css/Partners.css";

// api
import {
  // getCasebookLatestOne,
  getCaseBooksAll
  // getCaseBookDetail
} from "../api/CasebookApi.js";

function Casebook() {
  const [data, setData] = useState([]);
  const [maxItems, setMaxItems] = useState(4);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchData = async () => {
      // const result = await getCasebookLatestOne();
      const resultall = await getCaseBooksAll();
      console.log(resultall);
      setData(resultall);
    };

    fetchData();
  }, []);

  const handleClickDetail = (item) => {
    // console.log("아이템", item);
    navigate(`/media/casebooks/detail/${item.id}`, { state: item });
  };

  const handleLoadMore = () => {
    setMaxItems((prevMaxItems) => {
      if (window.innerWidth >= 1023 && window.innerWidth <= 1280) {
        return prevMaxItems + 3;
      } else {
        return prevMaxItems + 4;
      }
    });
  };

  return (
    <div className="casebook_page">
      <ScrollTop />

      {/* 페이지 타이틀명 설정 */}
      <Helmet>
        <title>레인보우브레인 | 지능형자동화 전문기업</title>
        <meta
          name="description"
          content="우리 회사에도 적용할 수 있을까? 실제 도입 사례로 확인해보세요."
        ></meta>
      </Helmet>

      <Content
        title="CASEBOOK"
        title1={
          <p className="content-title1">
            생성형 AI 도입 사례가 궁금하다면?
            <br />
            지금 사례집 신청하고, 실제 RAG 적용법을 확인해보세요.
          </p>
        }
      />

      <Route route1="MEDIA" route2="CASEBOOK"></Route>
      <div className="content_bg">
        <div className="container">
          <div className="example_wrap">
            <ul className="contents1 ex_list" style={{ paddingTop: "0px" }}>
              {data.slice(0, maxItems).map((item, index) => (
                <li className="news" key={index}>
                  <div
                    className="thum_hover"
                    key={item.id}
                    onClick={() => handleClickDetail(item)}
                  >
                    <img src={item.img} alt="썸네일" />
                  </div>

                  <div
                    className="news_thumbnail"
                    onClick={() => handleClickDetail(item)}
                  >
                    <p className="contents2 news_title">{item.title}</p>
                  </div>
                </li>
              ))}
            </ul>
          </div>

          {data.length > 4 && (
            <div className="contact_footer">
              <button
                type="button"
                className="blue_btn button1"
                onClick={handleLoadMore}
              >
                더보기
              </button>
            </div>
          )}
        </div>
      </div>

      <Slogan containerPadding="5vw 0" />
    </div>
  );
}

export default Casebook;
